import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { CdnImgModule } from "@webapp/shared/directives/cdn-img/cdn-img.module";
import { IndicatorModule } from "@webapp/shared/indicator/indicator.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiSkeletonModule } from "@webapp/ui/skeleton/skeleton.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { PlatformIntelligenceSharedModule } from "../shared/pi-shared.module";
import { QuantivePlusMetricsComponent } from "./components/quantive-plus-metrics/quantive-plus-metrics.component";
import { QuantivePlusObjectiveDescriptionComponent } from "./components/quantive-plus-objective-description/quantive-plus-objective-description.component";
import { QuantivePlusObjectiveTagsComponent } from "./components/quantive-plus-objective-tags/quantive-plus-objective-tags.component";
import { QuantivePlusSuggestionCardTagsComponent } from "./components/quantive-plus-suggestion-card-tags/quantive-plus-suggestion-card-tags.component";
import { QuantivePlusTasksComponent } from "./components/quantive-plus-tasks/quantive-plus-tasks.component";

@NgModule({
  imports: [
    CommonModule,
    PlatformIntelligenceSharedModule,
    UiIconModule,
    UiGridModule,
    UiButtonModule,
    LocalizationModule,
    IndicatorModule,
    UiTooltipModule,
    UiSkeletonModule,
    CdnImgModule,
  ],
  declarations: [
    QuantivePlusTasksComponent,
    QuantivePlusMetricsComponent,
    QuantivePlusObjectiveDescriptionComponent,
    QuantivePlusObjectiveTagsComponent,
    QuantivePlusSuggestionCardTagsComponent,
  ],
  exports: [
    QuantivePlusTasksComponent,
    QuantivePlusMetricsComponent,
    QuantivePlusObjectiveDescriptionComponent,
    QuantivePlusObjectiveTagsComponent,
    QuantivePlusSuggestionCardTagsComponent,
  ],
})
export class QuantivePlusModule {}
